import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { ROLE_EDIT } from '~/components/routes/administration/roles/permissions'
import { RoleForm } from '~/components/routes/administration/roles/role-form'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/administration/roles/$roleId/edit')({
  staticData: { permission: ROLE_EDIT },
  component: AdministrationRoleEditPage,
  params: {
    parse: z.object({ roleId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function AdministrationRoleEditPage() {
  const { roleId } = Route.useParams()

  return (
    <>
      <AppHeader>
        <Title>Administration</Title>
      </AppHeader>

      <AppContainer>
        <RoleForm mode="edit" roleId={roleId} />
      </AppContainer>
    </>
  )
}
